initTimeline();

function initTimeline() {
    const $timelineBlocks = $('.timeline-block');

    if (!$timelineBlocks.length) return;

    $timelineBlocks.each(function() {
        const $timeline = $(this);
        const $timelineItems = $timeline.find('.timeline-item');
        const $timelineImages = $timeline.find('.timeline-image');
        const $imageContainer = $timeline.find('.timeline-image-container');

        // Store timeline section boundaries
        let timelineTop, timelineBottom, containerHeight;

        // Calculate section boundaries on load and resize
        calculateBoundaries();
        $(window).on('resize', debounce(calculateBoundaries, 100));

        // Initial check
        handleScrollAndVisibility();

        // Listen for scroll events
        $(window).on('scroll', debounce(handleScrollAndVisibility, 50));

        /**
         * Calculate the boundaries of the timeline section
         */
        function calculateBoundaries() {
            timelineTop = $timeline.offset().top;
            timelineBottom = timelineTop + $timeline.outerHeight();
            containerHeight = $imageContainer.outerHeight();
        }

        /**
         * Handle visibility updates for timeline items
         */
        function handleScrollAndVisibility() {
            // Update which image is visible
            updateVisibleItem();

            // Check if timeline is visible in viewport
            const scrollTop = $(window).scrollTop();
            const windowHeight = $(window).height();

            // Add visibility class if timeline is in viewport
            if (scrollTop < timelineBottom && scrollTop + windowHeight > timelineTop) {
                $imageContainer.addClass('is-visible');
            } else {
                $imageContainer.removeClass('is-visible');
            }
        }

        /**
         * Determine which timeline item is currently in focus
         */
        function updateVisibleItem() {
            const scrollTop = $(window).scrollTop();
            const viewportHeight = $(window).height();
            const viewportMiddle = scrollTop + (viewportHeight / 2);
            const viewportBottom = scrollTop + viewportHeight;

            // Default to first image
            let activeIndex = 0;

            $timelineItems.each(function(index) {
                const $item = $(this);
                const itemTop = $item.offset().top;
                const itemHeight = $item.outerHeight();
                const itemBottom = itemTop + itemHeight;
                if ((itemTop < viewportMiddle && itemBottom > viewportMiddle) ||
                    (itemTop > scrollTop && itemTop < viewportBottom - 100)) {
                    activeIndex = parseInt($item.attr('data-index'));
                    return false; // Break the loop when we find the focused item
                }
            });

            // Update active image - only if different from current
            if (parseInt($imageContainer.attr('data-current-index') || 0) !== activeIndex) {
                updateActiveImage(activeIndex);
            }
        }

        /**
         * Update the active image based on the currently visible timeline item
         * @param {number} index - Index of the active timeline item
         */
        function updateActiveImage(index) {
            // Check if an image exists for this index
            const $targetImage = $timelineImages.filter(`[data-index="${index}"]`);

            if ($targetImage.length > 0) {
                // If image exists for this timeline item, show it
                $timelineImages.removeClass('active');
                $targetImage.addClass('active');
                $imageContainer.attr('data-current-index', index);
                console.log('Showing image for timeline item:', index);
            } else {
                // If no image exists, find the most recent timeline item that has an image
                let previousImageIndex = -1;

                // Loop backward from current index to find most recent item with image
                for (let i = index - 1; i >= 0; i--) {
                    if ($timelineImages.filter(`[data-index="${i}"]`).length > 0) {
                        previousImageIndex = i;
                        break;
                    }
                }

                // If found a previous item with image, keep that one active
                if (previousImageIndex >= 0) {
                    $timelineImages.removeClass('active');
                    $timelineImages.filter(`[data-index="${previousImageIndex}"]`).addClass('active');
                    $imageContainer.attr('data-current-index', index);
                    console.log('No image for current item. Keeping image from item:', previousImageIndex);
                }
            }
        }
    });
}

/**
 * Debounce function to limit how often a function is called
 * @param {Function} func - Function to debounce
 * @param {number} wait - Time in milliseconds to wait between calls
 * @returns {Function} - Debounced function
 */
function debounce(func, wait) {
    let timeout;

    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };

        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
